import React, { useState } from 'react';
// import AddItemSearchItem from '../components/addSearchItems/AddItemSearchItem';
import AddItemSearchItem from 'src/common/refactoredComponents/addItemSearchItem/AddItemSearchItem';
import PriceItemButton from 'src/pages/reportUsage/record/components/priceItems/priceItemButton';
import ItemListView from '../components/itemsList/index';
import PatientDetails from '../components/patientDetails/PatientDetails';
import SummaryMobile from '../components/summary/SummaryMobile';
import Signature from '../components/addSignature/signature';
import PriceOverrideButtonContainer from '../components/priceOverride/priceOverrideButtonContainer';
import { AddAndSearchItemContainer } from '../components/addSearchItems/AddItemSearchItem.styled';
import { useTranslation } from 'react-i18next';
import { ErrorMsgContainer } from '../components/itemsList/LotSerialQtyInput';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { noPriceErrorMsg } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { SubTitleComponent } from '../components/patientDetails/PatientDetails.styled';
import AccountSection from '../components/changeAccount/AccountSection';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import Button from 'src/common/components/button/Button';
import { DetailsMainContainer } from 'src/pages/consignmentAdd/components/account/AccountContainer.styled';
import Select from 'src/common/refactoredComponents/select/Select';
import { isMobileView, logErrorToConsole } from 'src/utils/util';
import { SurgeryDateViewAndNumber } from 'src/pages/scheduleSurgery/components/details/Details.styled';
import { sizes } from 'src/styles/Media.styled';
import { DropdownOption } from 'src/constants/templateConstants';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { Title } from 'src/pages/consignmentBilling/components/account/Details.styled';
import MessageTemplate from 'src/pages/equity/components/common/notifications/MessageTemplate';
import { useSelector } from 'react-redux';
import { VISIBLE } from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const RecordViewContainerDesktop = (props) => {
    const {
        filteredProduct,
        setFilteredProduct,
        isSelected,
        selectedProduct,
        addedProduct,
        optionValue,
        onSearchAddPress,
        buttonList,
        autoCompleteInputChange,
        cancelSearchRequest,
        open,
        setOpen,
        handleOnOpen,
        onSelectItem,
        addItemChange,
        productsList,
        productListLoading,
        successMessage,
        setSuccessMessage,
        updateSelectedProduct,
        toggleHidePricesBtn,
        setToggleHidePricesBtn,
        showHidePricesBtn,
        setShowHidePricesBtn,
        isButtonDisabled,
        isBundle,
        priceOverrideClickHandler,
        showBundlefromTableList,
        addedChildProduct,
        selectedChildProduct,
        resetSelectedOrAddedItem,
        priceOverrideReason,
        setPriceOverrideReason,
        setPricingNotes,
        vendorCaseErrorRedirection,
        isAccountCardExpanded,
        setIsAccountCardExpanded,
        handleInputChange,
        accounts,
        accountId,
        AccountTemplate,
        accountValue,
        isAccountsOptionLoading,
        handleSearch,
        handleClosePopUp,
        blockedAccountMessage,
        setBlockedAccountMessage,
        handleOnfocus,
        closeKeyBoard,
        usageDetails,
        onBlur,
        showReportPayment,
        showUnidInfoScreen,
        isReportPaymentBtnDisabled,
        currentActivity,
        showORreportScreen,
        reportPaymentBtnClickHandler,
        setreportBtnClicked,
        countryCode,
        priceOverrideReportUsageVisibility,
        reportPaymentTable = true,
        isQtyInvalid,
        isErrorExists,
        setIsReportPaymentScreen,
        reportUsagePatientDetails,
        saveExitBtnClickHandler,
        numberOfSurgery,
        setNumberOfSurgery,
        surgeryNumberReportUsageVisibility,
        surgeryNumberReportUsageMandatory,
        addItemSearchItem,
        signatureVisibilityUsage,
        bulkAddValue,
        setBulkAddValue,
        activeScanTab,
        setActiveScanTab,
        externalBarcode,
        setExternalBarcode,
    } = props;

    const { t } = useTranslation();
    const [isPatientDetailsVisible, setPatientDetailsVisible] = useState(true);

    const validateAccount = useSelector(
        (state) => state.surgeryvalidateAccountReducer.validateAccount
    );

    useEffectWithErrorLogging(() => {
        if (
            validateAccount.data.blockMessage &&
            blockedAccountMessage === false
        ) {
            setBlockedAccountMessage(true);
        }
    }, [validateAccount]);

    return (
        <div>
            <SubTitleComponent>
                {t('reportUsage.recordUsageTitle')}
            </SubTitleComponent>
            {usageDetails?.changeAccountEnabled && (
                <AccountSection
                    isAccountCardExpanded={isAccountCardExpanded}
                    setIsAccountCardExpanded={setIsAccountCardExpanded}
                    handleInputChange={handleInputChange}
                    accounts={accounts}
                    accountId={accountId}
                    AccountTemplate={AccountTemplate}
                    accountValue={accountValue}
                    isAccountsOptionLoading={isAccountsOptionLoading}
                    handleSearch={handleSearch}
                    handleOnfocus={handleOnfocus}
                    closeKeyBoard={closeKeyBoard}
                    cardWidth={'50%'}
                    onBlur={onBlur}
                    usageDetails={usageDetails}
                />
            )}
            {reportUsagePatientDetails?.length > 0 && (
                <PatientDetails
                    patientDetails={props.patientDetails}
                    setPatientDetails={props.setPatientDetails}
                    usageDetails={props.usageDetails}
                    errForEmptyHrefIdField={props.errForEmptyHrefIdField}
                    setErrForEmptyHrefIdField={props.setErrForEmptyHrefIdField}
                    errForEmptyPatientField={props.errForEmptyPatientField}
                    setErrForEmptyPatientField={
                        props.setErrForEmptyPatientField
                    }
                    countryCode={countryCode}
                />
            )}
            {surgeryNumberReportUsageVisibility === VISIBLE && (
                <CollapsableCard id="reportUsage-recordViewContainerDesktop-record-procedureDetails"
                    padding={'20px 24px 4px 21px'}
                    margin={'0px 2px 16px 1px'}
                    fontFamily={'AvenirNextWorld Demi'}
                    // fontWeight={'bold'}
                    title={t('common.procedureDetails')}
                    onClick={() => setPatientDetailsVisible(!isPatientDetailsVisible)}
                    isExpanded={isPatientDetailsVisible}
                    currentActivity                    
                >
                    <DetailsMainContainer>
                        {surgeryNumberReportUsageVisibility === VISIBLE && (
                            <SurgeryDateViewAndNumber isConsignmentAdd={true}>
                                <Title
                                    showAstrisk={
                                        surgeryNumberReportUsageMandatory ===
                                        'YES'
                                            ? true
                                            : false
                                    }
                                >
                                    {t('common.surgeryNumberLabel')}
                                </Title>

                                <Select
                                    id="reportUsage-recordViewContainerDesktop-record-surgeryNumberLabel"
                                    value={numberOfSurgery}
                                    options={DropdownOption().numberOfSurgery}
                                    onChange={(count) => {
                                        setNumberOfSurgery(count);
                                    }}
                                    width={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? '100%'
                                            : '200px'
                                    }
                                    smWidth="100%"
                                    xSmWidth="40%"
                                    defaultValue={numberOfSurgery}
                                />
                            </SurgeryDateViewAndNumber>
                        )}
                    </DetailsMainContainer>
                </CollapsableCard>
            )}
            <AddAndSearchItemContainer
                marginLeft={'none'}
                marginLeftInput={'none'}
            >
                <AddItemSearchItem
                    id='reportUsage-recordView'
                    isReportUsage={true}                    
                    checkLotSerial={true}
                    orderType={'ZLC'}
                    addItemSearchTerm={addItemSearchItem}
                    buttonList={buttonList}
                    onSearchAddPress={onSearchAddPress}
                    bulkAddValue={bulkAddValue}
                    setBulkAddValue={setBulkAddValue}
                    activeScanTab={activeScanTab}
                    setActiveScanTab={setActiveScanTab}
                    externalBarcode={externalBarcode}
                    setExternalBarcode={setExternalBarcode}
                    selectedProduct={selectedProduct}
                    isSelected={isSelected}
                    addItemPlaceholder={t(
                        'reportUsage.addItems.enterCfnOrItemNumber'
                    )}
                    autoCompleteData={productsList}
                    autoCompleteDataLoading={productListLoading}
                    optionValue={optionValue}
                    optionLabelKey={''}
                    autoCompletePlaceholder={t(
                        'reportUsage.searchItems.searchByItemNameorNumber'
                    )}
                    autoCompleteInputChange={autoCompleteInputChange}
                    onClose={() => {
                        try {
                        setOpen(false);
                        cancelSearchRequest();
                        } catch (error) {
                            logErrorToConsole(error);
                       }
                    }}
                    setOpen={setOpen}
                    onChange={updateSelectedProduct}
                    handleOnOpen={handleOnOpen}
                    open={open}
                    onSelectItem={onSelectItem}
                    addItemChange={addItemChange}
                    succesMessage={successMessage}
                    setSuccesMesssage={setSuccessMessage}
                    filteredProduct={filteredProduct}
                    setFilteredProduct={setFilteredProduct}
                    accountId={accountId}
                />
            </AddAndSearchItemContainer>
            {filteredProduct?.length > 0 &&
                filteredProduct.some(
                    (item) => item.exclusionStatus === noPriceErrorMsg
                ) && (
                    <ErrorMsgContainer padding={'18px 0 10px'}>
                        <AlertMsg
                            message={t(
                                'productValidationMessages.noPriceErrorMsg'
                            )}
                        />
                    </ErrorMsgContainer>
                )}
            <ItemListView
                selectedProduct={selectedProduct}
                addedProduct={addedProduct}
                setShowHidePricesBtn={setShowHidePricesBtn}
                toggleHidePricesBtn={toggleHidePricesBtn}
                setToggleHidePricesBtn={setToggleHidePricesBtn}
                isBundle={isBundle}
                selectedChildProduct={selectedChildProduct}
                addedChildProduct={addedChildProduct}
                showBundlefromTableList={showBundlefromTableList}
                filteredProduct={filteredProduct}
                setFilteredProduct={setFilteredProduct}
                resetSelectedOrAddedItem={resetSelectedOrAddedItem}
                setPriceOverrideReason={setPriceOverrideReason}
                setPricingNotes={setPricingNotes}
                vendorCaseErrorRedirection={vendorCaseErrorRedirection}
            />
            {filteredProduct?.length > 0 && (
                <>
                    <PriceItemButton
                        toggleHidePricesBtn={toggleHidePricesBtn}
                        setToggleHidePricesBtn={setToggleHidePricesBtn}
                        showHidePricesBtn={showHidePricesBtn}
                        tableData={filteredProduct}
                        setFilteredProduct={setFilteredProduct}
                        showReportPayment={showReportPayment}
                        showUnidInfoScreen={showUnidInfoScreen}
                        isReportPaymentBtnDisabled={isReportPaymentBtnDisabled}
                        currentActivity={currentActivity}
                        showORreportScreen={showORreportScreen}
                        reportPaymentBtnClickHandler={
                            reportPaymentBtnClickHandler
                        }
                        setreportBtnClicked={setreportBtnClicked}
                        countryCode={countryCode}
                        patientDetails={props.patientDetails}
                        priceOverrideReportUsageVisibility={
                            priceOverrideReportUsageVisibility
                        }
                        isQtyInvalid={isQtyInvalid}
                        isErrorExists={isErrorExists}
                        saveExitBtnClickHandler={saveExitBtnClickHandler}
                        isReportUsage={true}
                    />
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingBottom: '10px',
                        }}
                    >
                        {!(
                            priceOverrideReportUsageVisibility === 'NOT_VISIBLE'
                        ) ? (
                            <PriceOverrideButtonContainer
                                btnDisabled={
                                    isButtonDisabled ||
                                    toggleHidePricesBtn !== 'hideBtn'
                                }
                                priceOverrideClickHandler={
                                    priceOverrideClickHandler
                                }
                                priceOverrideReason={priceOverrideReason}
                                show={'flex'}
                            />
                        ) : null}
                        {signatureVisibilityUsage=== VISIBLE && <Signature btnDisabled={isButtonDisabled} {...props} />}
                    </div>
                    {filteredProduct.some(
                        (item) => item.basePrice && item.basePrice.length > 0
                    ) && (
                        <SummaryMobile
                            itemTableData={filteredProduct}
                            displayPrice={
                                props.toggleHidePricesBtn === 'hideBtn'
                            }
                            accountLabel={t('reportUsage.summary.accountOwned')}
                            accountNotBilled={t(
                                'reportUsage.summary.notBilled'
                            )}
                            isDesktop
                        />
                    )}
                </>
            )}
            {blockedAccountMessage ? (
                <MessageTemplate
                    isDeliveryCheck={true}
                    onClose={() => {
                        try {
                        handleClosePopUp();
                        } catch (error) {
                            logErrorToConsole(error);
                       }
                    }}
                    content={validateAccount.data.blockMessage}
                    width={'100%'}
                    marginB={'32px'}
                    position={'static'}
                    height={'auto'}
                    title={t(
                        'ConsignmentAdd.surgery.notifications.accountBlocked'
                    )}
                    fontWeight={'800'}
                    blocked
                />
            ) : null}
        </div>
    );
};

export default RecordViewContainerDesktop;
